












import { Vue, Component, Prop } from 'vue-property-decorator';
import EditorSection from '@/editor/editor-block-view/components/EditorSection.vue';
import { IEditorContent, ISection, IMergeValues } from '@/editor/types';

@Component({
  components: {
    EditorSection,
  },
})
export default class EditorBlockView extends Vue {
  @Prop() content: IEditorContent;
  @Prop() mergeValues: IMergeValues;

  get sections(): ISection[] {
    return this.content?.sections;
  }

  mounted() {
    this.$emit('loaded');
  }
}
